const preset = (group, id, labelKey, width, height, ratio) => ({
  id: `${group}-${id}`,
  group,
  labelKey,
  width,
  height,
  ratio,
});

export const FORMAT_PRESETS = [
  preset('instagram', 'portrait', 'presetPortraitPost', 1080, 1350, '4:5'),
  preset('instagram', 'square', 'presetSquarePost', 1080, 1080, '1:1'),
  preset('instagram', 'story', 'presetStoryReel', 1080, 1920, '9:16'),

  preset('facebook', 'post', 'presetPost', 1080, 1350, '4:5'),
  preset('facebook', 'link', 'presetLinkImage', 1200, 630, '1.91:1'),
  preset('facebook', 'cover', 'presetPageCover', 851, 315, '2.7:1'),

  preset('x', 'post', 'presetPost', 1600, 900, '16:9'),
  preset('x', 'header', 'presetProfileHeader', 1500, 500, '3:1'),

  preset('linkedin', 'square', 'presetSquarePost', 1200, 1200, '1:1'),
  preset('linkedin', 'landscape', 'presetLandscapePost', 1200, 627, '1.91:1'),
  preset('linkedin', 'banner', 'presetProfileBanner', 1584, 396, '4:1'),

  preset('youtube', 'thumbnail', 'presetVideoThumbnail', 1280, 720, '16:9'),
  preset('youtube', 'banner', 'presetChannelBanner', 2560, 1440, '16:9'),
];

export const FORMAT_PRESET_GROUPS = [
  { id: 'instagram', labelKey: 'presetGroupInstagram' },
  { id: 'facebook', labelKey: 'presetGroupFacebook' },
  { id: 'x', labelKey: 'presetGroupX' },
  { id: 'linkedin', labelKey: 'presetGroupLinkedIn' },
  { id: 'youtube', labelKey: 'presetGroupYouTube' },
];

export const MIN_OUTPUT_EDGE = 16;
export const MAX_OUTPUT_EDGE = 8192;
